import {Form, FormGroup, Modal, ModalBody, ModalHeader} from "reactstrap";
import DragDropFile from "../DragDropFile";
import ButtonWithSpinner from "../ButtonWithSpinner";
import get from "lodash/get";
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import {isMobileDevice} from "../../index";
import {
    addingNewContactRequestStart,
    addingNewContactToggleModal,
    addingNewContactTouchForm, importNewContactsRequestStart, importNewContactsToggleModal, importNewContactsTouchForm
} from "../../actions/Chats";
import {useDispatch, useSelector} from "react-redux";

const ImportContactsModal = () => {
    const {t, i18n} = useTranslation();

    // --------------------------
    // Hooks
    // --------------------------
    // componentDidMount && componentWillUnmount


    const importNewContactsStateModal = useSelector((state) => state.Chats.importNewContactsStateModal)
    const importNewContactsErrors = useSelector((state) => state.Chats.importNewContactsErrors)
    const importNewContactsLoading = useSelector((state) => state.Chats.importNewContactsLoading)
    const dispatch = useDispatch();
    const [importNewContactsFile, setImportNewContactsFile] = useState('');

    useEffect(() => {
        if (!importNewContactsStateModal) {
            setImportNewContactsFile('');
            dispatch(importNewContactsTouchForm());
        }
    }, [importNewContactsStateModal]);

    const sendImportNewContactsRequest = (e) => {
        e.preventDefault();
        dispatch(importNewContactsRequestStart(importNewContactsFile.file));
    }


    return <Modal isOpen={importNewContactsStateModal}
                  toggle={() => dispatch(importNewContactsToggleModal(!importNewContactsStateModal))}>
        <ModalHeader>{t('chats.modal_import_new_contacts.import_new_contacts', "Import new contacts")}</ModalHeader>
        <ModalBody>
            <Form onSubmit={sendImportNewContactsRequest} autoComplete="on">
                <FormGroup>
                    <DragDropFile
                        handleChange={setImportNewContactsFile}
                        handleClick={() => {
                            dispatch(importNewContactsTouchForm)
                        }}
                        title={t('chats.modal_import_new_contacts.to_add_a_file', "To add a file")}
                        fileTypes={["text/csv"]}/>
                </FormGroup>
                <div
                    className="text-center mt-3 mb-3">{t('chats.modal_import_new_contacts.import_new_contacts_description', "Import new contacts description")}</div>
                <div className="d-flex justify-content-center">
                    <ButtonWithSpinner title={t('chats.modal_import_new_contacts.upload', "Upload")}
                                       type="submit" loading={importNewContactsLoading}
                                       disabled={!importNewContactsFile.file || importNewContactsFile.fileType != "text/csv"}/>
                </div>
                <div className="text-center text-danger mt-3">{get(importNewContactsErrors, 'common')}</div>
                <div className="text-danger mr-3 mt-3">{get(importNewContactsErrors, 'phone_invalid')}</div>
            </Form>
        </ModalBody>
    </Modal>
}
export default ImportContactsModal;